import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentWstoConsumerCountryCannotBeEmptyError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.wsto-document.consumer-country-is-empty');
    }
}
